import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

const HEIGHT = 38

export const Container = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: theme.spacing(2),
    height: HEIGHT,
}))

export const Label = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/tertiary"].main,
}))

export const LogoWrapper = styled("div")(() => ({
    aspectRatio: "auto",
    height: "100%",
}))